var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoteOff(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M0 0h25v25H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#333",
    fillRule: "nonzero",
    stroke: "#333",
    strokeWidth: 0.3,
    opacity: 0.318
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.882 8.903l-1.105 1.167-.138-.145 1.105-1.167.138.145-5.808 6.135-.137-.144 4.702-4.969-1.546-1.633-3.02 3.19-.136-.145 3.156-3.335 1.752 1.851h-.137l1.036-1.095zM7.313 8.78v-.204l3.912-.002v.205zM7.358 12.056v-.205h5.978v.205zM7.367 15.426v-.205h5.979v.204z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.102 14.719v5.225H5V3h13.102v8.451l-.056.06-.07-.072.07.073-2.854 3.014-.351 2.008 1.897-.374 1.364-1.441zm-.166-3.382l.07.072h-.098V3.205H5.194v16.534h12.714v-4.526l-1.075 1.137-2.234.44.413-2.363 2.896-3.06.028-.03zM20.859 8.25l1.202-1.27.137.144-1.065 1.125z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.95 8.83l-1.173 1.24-1.82-1.923 1.173-1.24 1.82 1.923zm-1.82-1.633l-.9.95 1.547 1.634.899-.95-1.546-1.634z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoteOff);
export default __webpack_public_path__ + "static/media/note-off.d0a635e32ba5620a95d8997347942024.svg";
export { ForwardRef as ReactComponent };